module.exports = __webpack_public_path__ + "static/img-paris-90526c08d3f645a6f08d1efc550043d8.png";